import { codeLabel } from '@bemor/web-kit';
import type { SelectOption } from '@bemor/web-kit/ui';

/** The choices of a select from codes or given options, labelled by the kit's `codeLabel` (a code in sentence case). */
export function optionsOf(
    list: readonly (string | SelectOption)[],
): SelectOption[] {
    return list.map((o) =>
        typeof o === 'string' ? { value: o, label: codeLabel(o) } : o,
    );
}
